export const GENERIC_ERROR_MESSAGE =
  'Yikes! Something went wrong when trying to sign up. If you keep having trouble, please contact support.';
export const SIGNUP_USE_DIFFERENT_EMAIL =
  'Please choose a different email address.';
export const ZAPIER_USER_CREATED_EVENT_PROVISIONING_METHOD_PARTNER_QUAC =
  'partner_quick_account_creations';
